import React, { useRef, useState } from 'react';

import * as S from './styles';
import { PlayIcon } from '@/assets/icons/PlayIcon';

interface VideoPlayerProps {
	src?: string;
	title?: string;
}

export function VideoPlayer({ src, title }: Readonly<VideoPlayerProps>): JSX.Element {
	const videoRef = useRef<HTMLVideoElement>(null);
	const [isPlaying, setIsPlaying] = useState(false);

	function handleVideoClick() {
		if (videoRef.current) {
			if (videoRef.current.paused) {
				videoRef.current.play();
			} else {
				videoRef.current.pause();
			}
		}
	}

	function handleLoadedMetadata() {
		if (videoRef.current) {
			videoRef.current.currentTime = 0.1;
		}
	}

	return (
		<S.VideoThumbnail onClick={handleVideoClick}>
			<video
				key={src}
				width="100%"
				height="100%"
				ref={videoRef}
				preload="metadata"
				title={title}
				style={{ width: '100%', height: '100%', objectFit: 'cover' }}
				controls={false}
				onLoadedMetadata={handleLoadedMetadata}
				onPlay={() => setIsPlaying(true)}
				onPause={() => setIsPlaying(false)}
				onEnded={() => setIsPlaying(false)}
			>
				<source src={src} type="video/mp4" />
				Your browser does not support the video tag.
			</video>
			{!isPlaying && (
				<S.PlayButton>
					<PlayIcon />
				</S.PlayButton>
			)}
		</S.VideoThumbnail>
	);
}
